export default __webpack_public_path__ + "static/cardContent-a438a7037ff7f5c82693b50ff7959fcd.png";